import { FiGift, FiRefreshCw, FiBriefcase, FiStar } from 'react-icons/fi'
import { ROUTES } from '@/constants/routes'
import type { DonateTier } from '@/types/donate'

export const PAYPAL_EMAIL = 'ibonworld@gmail.com'

export const tiers: DonateTier[] = [
  {
    Icon: FiGift,
    title: 'One-Time Gift',
    text: 'Make a single contribution to support our programmes and initiatives.',
    cta: 'Donate to a Project',
    to: '#give-now',
  },
  {
    Icon: FiRefreshCw,
    title: 'Monthly Giving',
    text: 'Become a recurring donor and sustain long-term impact every month.',
    cta: 'Become a Monthly Donor',
    to: '#give-now',
  },
  {
    Icon: FiBriefcase,
    title: 'Corporate Giving',
    text: 'Align your organisation with our mission through corporate support.',
    cta: 'Become a Partner',
    to: `${ROUTES.CONTACT}?interest=Partnership Opportunity`,
  },
  {
    Icon: FiStar,
    title: 'Sponsorship',
    text: 'Sponsor a programme, event, or participant and create direct change.',
    cta: 'Sponsor a Programme',
    to: `${ROUTES.CONTACT}?interest=Partnership Opportunity`,
  },
]
